<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_add_tag"
          @click="submit"
        >設定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">タグの絞り込み</span>
          <a @click="routeTaglist()" role="button" class="popup-title-link">タグの管理</a>
        </div>
        <div class="popup-content">
          <div v-if="tags.length > 0" class="popup-content-1">
            <ul class="list-tag">
              <li v-for="(tag, index) in tags" :key="'tag_' + index" class="list-tag-item">
                <div class="tag bottom">
                  <div role="button" class="tag-wrap">
                    <span @click="setTags(tag)" class="tag-text">{{tag.name}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="filterTags.length > 0" class="popup-content-2">
            <ul class="list-tag">
              <li v-for="(tag, index) in filterTags" :key="'filterTag_' + index" class="list-tag-item">
                <div class="tag">
                  <div @click="resetTags(tag)" role="button" class="tag-wrap">
                    <span class="tag-text">{{tag.name}}</span>
                    <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as _ from 'lodash'

export default defineComponent({
  props: {
    data: {
      tags: {
        defalt: [],
        type: Array
      },
      filterTags: {
        defalt: [],
        type: Array
      }
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const router = context.root.$router
    const { bookmark } = store.state

    const close = () => {
      context.emit('closeBookmarkTagExtract')
    }
    const submit = () => {
      const tagNames = _.map(filterTags, tag => tag.id)
      store
        .dispatch('bookmark/setFilterTags', tagNames)
        .then(() => {
          store.dispatch('bookmark/resetLists')
        })
      context.emit('closeBookmarkTagExtract')
    }
    const setTags = (changeTag) => {
      const tagsIndex = _.findIndex(tags, tag => tag.name === changeTag.name)
      tags.splice(tagsIndex, 1)
      filterTags.push(changeTag)
    }

    const resetTags = (changeTag) => {
      tags.push(changeTag)
      const tagsIndex = _.findIndex(filterTags, tag => tag.name === changeTag.name)
      filterTags.splice(tagsIndex, 1)
    }

    const tags = []
    tags.push(...props.data.tags)
    const filterTags = reactive([])
    const searchedTags = _.filter(props.data.tags, tag => bookmark.filterTags.includes(tag.id))
    
    if (searchedTags.length > 0) {
      _.each(searchedTags, tag => setTags(tag))
    }

    const routeTaglist = () => {
      store.dispatch('tag/changeType', 'bookmark')
      router.push({ name: 'SPTagList' })
    }

    return {
      close,
      submit,
      setTags,
      resetTags,
      tags,
      filterTags,
      routeTaglist
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-title {
    position: relative;
    &-link {
      color: $color-link;
      font-size: 1.4rem;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translate3d(0,-50%,0);
    }
  }
  &-content {
    &-1 {
      background-color: $color-bg-paper;
      padding: 20px;
      border-bottom: 1px solid $color-line;
    }
    &-2 {
      padding: 20px;      
    }
  }
  .list-tag {
    margin-top: -8px;
    list-style: none;
    &-item {
      display: inline-block;
    }
  }
}
</style>
